"use client";

import useMediaQuery from "@mui/material/useMediaQuery";
import throttle from "lodash.throttle";
import React from "react";
import { useHydrated } from "src/hooks/use-hydrated";
import Topbar from "src/lib/components/header/footmart/top-bar";
import Sticky from "src/lib/components/header/footmart/Sticky";
import Header from "src/lib/components/header/footmart/header";

import MobileNavigationBar from "src/lib/components/header/footmart/mobile-navigation-bar";
import SearchInput from "./footmart/search-input";

export interface VariantProps {
  logoUrl?: string;
  name: string;
  nav: Array<{ label: string; url: string }>;
  notification: { type: "error"; label: string; text: string; bgColor: string };
  /** @default "/product" */
  productUrlPrefix?: string;
  /** @default "/checkout" */
  checkoutUrl?: string;
  /** @default "/cart" */
  cartUrl?: string;
  socialItems?: Array<{
    type: "facebook" | "twitter" | "youtube" | "pinterest" | "instagram";
    url: string;
  }>;
  colors: { primary: string };
}

const HeaderComponent: React.FC<VariantProps> = (props) => {
  const hydrated = useHydrated();
  const isMobileMq = useMediaQuery("(max-width:767px)");
  const isMobile = hydrated && isMobileMq;
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    setScrolled(isMobile ? window.pageYOffset >= 105 : window.pageYOffset >= 145);
    const handler = throttle(
      () => setScrolled(isMobile ? window.pageYOffset >= 105 : window.pageYOffset >= 145),
      25,
    );
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, [isMobile]);

  return (
    <>
      <Topbar
        socialLinks={props.socialItems}
        notification={props.notification}
        colors={props.colors}
      />

      <Sticky fixedOn={0} onSticky={false} scrollDistance={300}>
        <Header isFixed={scrolled} {...props} searchInput={<SearchInput />} />
      </Sticky>

      <MobileNavigationBar {...props} />
    </>
  );
};

HeaderComponent.displayName = "Header";

export default HeaderComponent;
